import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

// payload: { limit, nextToken }
export const getModelsApi = async (payload = {}, authHeaders) => {
    try {
        const body = {
            apiVerb: 'GET',
            limit: payload.limit,
            nextToken: payload.nextToken
        };
        const res = await apiCallPost(apiPaths.getModels, body, authHeaders);
        if (res) {
            return { data: res, status: true }
        }
        return { data: { items: [] }, status: false, errMsg: 'Some Error Occurred' };
    } catch (err) {
        return { status: false, errMsg: err.message }
    }
}